import React from 'react';

export const ListContext = React.createContext(null);
